import { ErrorMessage } from "@hookform/error-message";
import PropTypes from "prop-types";
import React from "react";

const MessageFormValidateV2 = props => {
  const { errors, fieldName } = props;

  return (
    <React.Fragment>
      <ErrorMessage
        errors={Object(errors || {})}
        name={fieldName}
        render={({ message }) => {
          return (
            <p className="text-danger" style={{ marginTop: "3px" }}>
              {message}
            </p>
          );
        }}
      />
    </React.Fragment>
  );
};

MessageFormValidateV2.propTypes = {
  errors: PropTypes.object.isRequired,
  fieldName: PropTypes.string.isRequired,
};

MessageFormValidateV2.defaultProps = {
  errors: {},
  fieldName: "",
};

export default MessageFormValidateV2;
